export const Path = {
  signIn: '/sign-in',
  signUp: '/sign-up',
  // Forwards to the Home Page preference, or to the AI Assistant (HomeRedirect).
  home: '/',
  profile: '/me/profile',
  preferences: '/me/preferences',
  preferencesTab: (preferenceTabSlug: string) => `/me/preferences/${preferenceTabSlug}`,
  tables: '/tables/',
  aiChat: '/ai',
  // Stored conversations live in the AI Assistant's own area, so Home and
  // the module's navigation treat them as part of it.
  aiChatThreadsRoot: '/ai/chat',
  aiChatThread: (threadId: string) => `/ai/chat/${encodeURIComponent(threadId)}`,
  legacyAiChat: '/assistant',
  settings: '/settings',
  settingsOrganization: '/settings/organization',
  settingsCredentials: '/settings/credentials',
  settingsPeriods: '/settings/periods',
  settingsPeriodsPayroll: '/settings/periods/payroll',
  settingsPeriodsTimesheets: '/settings/periods/timesheets',
  settingsPeriodsHolidays: '/settings/periods/holidays',
  settingsPeriodsCustom: '/settings/periods/custom',
  settingsGeneral: '/settings/general',
  settingsModules: '/settings/modules',
  usersRoot: '/users',
  users: '/users/users',
  automationsRoot: '/automations',
  automationsOverview: '/automations/overview',
  automations: '/automations/automations',
  automationNew: '/automations/automations/new',
  automation: (automationId: string) =>
    `/automations/automations/${encodeURIComponent(automationId)}`,
  automationConfiguration: (automationId: string) =>
    `/automations/automations/${encodeURIComponent(automationId)}/configurations`,
  automationVersions: (automationId: string) =>
    `/automations/automations/${encodeURIComponent(automationId)}/versions`,
  automationRuns: '/automations/runs',
  automationRunHistory: (automationId: string) =>
    `/automations/automations/${encodeURIComponent(automationId)}/runs`,
  integrationsRoot: '/integrations',
  integrationsOverview: '/integrations/overview',
  integrationsSources: '/integrations/sources',
  integrationsSource: (connectionId: string) =>
    `/integrations/sources/${encodeURIComponent(connectionId)}`,
  integrationsSourceTables: (connectionId: string) =>
    `/integrations/sources/${encodeURIComponent(connectionId)}/tables`,
  integrationsSourceSettings: (connectionId: string) =>
    `/integrations/sources/${encodeURIComponent(connectionId)}/settings`,
  integrationsSourceRuns: (connectionId: string) =>
    `/integrations/sources/${encodeURIComponent(connectionId)}/runs`,
  integrationsSourceFields: (connectionId: string) =>
    `/integrations/sources/${encodeURIComponent(connectionId)}/fields`,
  integrationsTables: '/integrations/tables',
  integrationsTable: (tableId: string) => `/integrations/tables/${encodeURIComponent(tableId)}`,
  integrationsTableSettings: (tableId: string) =>
    `/integrations/tables/${encodeURIComponent(tableId)}/settings`,
  integrationsTableFields: (tableId: string) =>
    `/integrations/tables/${encodeURIComponent(tableId)}/fields`,
  integrationsFields: '/integrations/fields',
  integrationsRuns: '/integrations/runs',
  integrationsRun: (runId: string) => `/integrations/runs/${encodeURIComponent(runId)}`,
  usersPermissionGroups: '/users/permission-groups',
  usersPreferenceGroups: '/users/preference-groups',
  usersPreferenceDefaults: '/users/preference-defaults',
  usersPreferenceDefaultsTab: (preferenceTabSlug: string) =>
    `/users/preference-defaults/${preferenceTabSlug}`,
  usersPreferenceGroup: (preferenceGroupId: string) =>
    `/users/preference-groups/${preferenceGroupId}`,
  usersPreferenceGroupTab: (preferenceGroupId: string, preferenceTabId: string) =>
    `/users/preference-groups/${preferenceGroupId}/tabs/${preferenceTabId}`,
  usersPermissionGroup: (userGroupId: string) => `/users/permission-groups/${userGroupId}`,
  usersPermissionGroupMembership: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/membership`,
  usersPermissionGroupGeneral: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/general`,
  usersPermissionGroupTables: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/tables`,
  usersPermissionGroupColumns: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/columns`,
  usersPermissionGroupModules: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/modules`,
  usersPermissionGroupRecords: (userGroupId: string) =>
    `/users/permission-groups/${userGroupId}/records`,
  tableRecords: (tableId: string) => `/tables/${tableId}`,
  tableDefaultViewRecords: (tableId: string, defaultViewId?: string | null) =>
    `/tables/${tableId}/table-views/${defaultViewId ?? 'all'}/records`,
  tableViewRecords: (tableId: string, viewId: string) =>
    `/tables/${tableId}/table-views/${viewId}/records`,
  tableViewSettings: (tableId: string, viewId: string) =>
    `/tables/${tableId}/table-views/${viewId}/settings`,
  tableSettings: (tableId: string) => `/tables/${tableId}/settings`,
  tableFieldMeta: (tableId: string, fieldId: string, metaTab: string) =>
    `/tables/${tableId}/fields/${fieldId}/meta/${metaTab}`,
}
